// src/algorithms/halftone/_runner.ts
import frag from '../shaders/halftone.frag?raw';
import { FULLSCREEN_VERT, createFullscreenQuad, linkProgram } from '../../core/gl';

export type HalftoneShape = 'dot' | 'line' | 'cross' | 'diamond' | 'square';
export const SHAPE_INDEX: Record<HalftoneShape, number> = {
  dot: 0, line: 1, cross: 2, diamond: 3, square: 4,
};

export interface HalftoneProgram {
  program: WebGLProgram;
  vao: WebGLVertexArrayObject;
  u: {
    src: WebGLUniformLocation | null;
    palette: WebGLUniformLocation | null;
    srcSize: WebGLUniformLocation | null;
    paletteSize: WebGLUniformLocation | null;
    scale: WebGLUniformLocation | null;
    angleRad: WebGLUniformLocation | null;
    shape: WebGLUniformLocation | null;
  };
}

export function createHalftoneProgram(gl: WebGL2RenderingContext): HalftoneProgram {
  const program = linkProgram(gl, FULLSCREEN_VERT, frag);
  const vao = createFullscreenQuad(gl);
  return {
    program, vao,
    u: {
      src:         gl.getUniformLocation(program, 'u_src'),
      palette:     gl.getUniformLocation(program, 'u_palette'),
      srcSize:     gl.getUniformLocation(program, 'u_srcSize'),
      paletteSize: gl.getUniformLocation(program, 'u_paletteSize'),
      scale:       gl.getUniformLocation(program, 'u_scale'),
      angleRad:    gl.getUniformLocation(program, 'u_angleRad'),
      shape:       gl.getUniformLocation(program, 'u_shape'),
    },
  };
}
